import type { Incident, IncidentsPayload } from '@cobliteam/common-types';
import type { Configuration, IRequest } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import TimeZone from '../../request/Timezone';
import { incidentsPayloadTransformer, incidentsTransformer } from './IncidentsTransformer';

class IncidentsRequester {
  private requester: Requester;

  private baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/herbie-1.1';
  }

  public getRequester = () => this.requester;

  public getIncidents = (data: IncidentsPayload): Promise<Incident[]> => {
    const incidentsData = incidentsPayloadTransformer(data);
    const tz = TimeZone.getEncodedTimeZone();

    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/stats/incidents?&end=${incidentsData.end_time}&tz=${tz}&amount=${incidentsData.amount}`,
      method: HttpMethod.GET,
    };

    return this.requester.request(requestData).then((response) => incidentsTransformer(response.data).sort((a, b) => (a.date > b.date ? -1 : 1)));
  };
}

export default IncidentsRequester;
